"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_warning__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "6ebe8659-1e83-4149-a95b-69bdf9ff162f",
    "data-name": "Warning_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "db5649c8-960a-4373-9a62-9f59c2ab9c14",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ccdc3dab-bc48-496c-a8a4-45cb0e7b35cb",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "7ebf36d1-e8eb-42a2-8667-f80b36c6bba9",
    "data-name": "<Pfad>",
    d: "M168.43,140.26c8.36,14.8,1.52,27.74-15.2,27.74H38.77c-16.72,0-23.57-12.94-15.2-27.74L80.8,35.05c8.33-14.35,22-15.11,30.41,0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.23,166H38.77c-11.42,0-18.23-6-18.74-14.58C19.53,161,26.48,168,38.77,168H153.23c12.29,0,19.24-7,18.74-16.58C171.46,160,164.65,166,153.23,166Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("line", {
    id: "30efbfa3-d636-4ed7-ac15-cf8e2bcac8ad",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 64,
    x2: 96,
    y2: 120.5,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "0362057e-8de3-44fb-a9cb-140c7162f641",
    "data-name": "<Pfad>",
    cx: 96,
    cy: 139.89,
    r: 6,
    fill: "#e60000"
  }))), /*#__PURE__*/React.createElement("title", null, "warning-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "3c5f977a-70d4-4f42-9a94-48f439da8a65",
    "data-name": "Warning_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "04bdf5df-466d-4560-882d-9b4cd561af1a",
    "data-name": "Warning_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#6ebe8659-1e83-4149-a95b-69bdf9ff162f"
  })));
}

var _default = ic_warning__dark;
exports.default = _default;